import React from "react";
import Discussion from "../../components/Inspections/Discussion";
export default function ReviewDiscussion(props) { return <Discussion {...props} />; }
